import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { ContentLanguage, UILanguage } from '@/types'

export type I18nState = {
  /** Verfügbare UI-Languages */
  uiLanguages: UILanguage[]
  /** Aktive UI-Language */
  uiLanguage: UILanguage
  /** Verfügbare Content-Languages */
  contentLanguages: ContentLanguage[]
  /** Aktive UI-Language */
  contentLanguage: ContentLanguage
}

export const useI18nStore = defineStore('i18n', () => {
  // State
  const uiLanguages = ref<UILanguage[]>(['de', 'it', 'en'])
  const uiLanguage = ref<UILanguage>('de')
  const contentLanguages = ref<ContentLanguage[]>(['de', 'it', 'en'])
  const contentLanguage = ref<ContentLanguage>('de')

  // Actions
  function setUiLanguage(lang: UILanguage) {
    uiLanguage.value = lang
  }
  function setUiLanguages(langs: UILanguage[]) {
    uiLanguages.value = langs
  }
  function setContentLanguage(lang: ContentLanguage) {
    contentLanguage.value = lang
  }
  function setContentLanguages(langs: ContentLanguage[]) {
    contentLanguages.value = langs
  }

  // Getters
  const getUiLanguage = computed(() => uiLanguage.value)
  const getUiLanguages = computed(() => uiLanguages.value)
  const getContentLanguage = computed(() => contentLanguage.value)
  const getContentLanguages = computed(() => contentLanguages.value)

  return {
    uiLanguages,
    uiLanguage,
    contentLanguages,
    contentLanguage,
    setUiLanguage,
    setUiLanguages,
    setContentLanguage,
    setContentLanguages,
    getUiLanguage,
    getUiLanguages,
    getContentLanguage,
    getContentLanguages
  }
})